import { useTranslation } from "react-i18next";
import PageHeaderAllPage from "../../Components/layouts/PageHeaderAllPage";
import Preloader from "../../Components/Preloader";
import Section1 from "../../Components/Sections/Section1";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navbar type="internal" />
      <Preloader />
      <main className="main">
        <PageHeaderAllPage
          tone="brand"
          showMenu
          current={t("menu.aboutUs")}
          banner="assets/imgs/page-header/banner.png"
          link="about"
        />
        <Section1 />
        {/* <Team2 className="border-top border-bottom" /> */}
        {/* <Cta8 /> */}
        {/* <Static1 classNameList="background-2 pt-80 pb-80" />
        <Cta9 />
        <Testimonials2 />
        <Faq1 />
        <Blog1 /> */}

        <Footer type="external" />
      </main>
    </>
  );
};
export default AboutUs;
